const CasesList = () => import("@/components/atm-front/cases/CasesList.vue");
const Case = () => import("@/components/atm-front/cases/Case.vue");

import CaseChildrens from "./case/case-children";

export default [
  {
    path: "",
    name: "casesList",
    component: CasesList,
  },
  {
    // L.B 21/07/26 No blocking beforeEnter guard: navigation to the case is instant and the
    // Case component loads its data behind a loader (see Case.vue). This avoids
    // the user lingering on the list while the route's data is fetched.
    path: ":caseNumber",
    component: Case,
    children: CaseChildrens,
  },
];
